import "./FormBox.scss";

const FormBox = ({children, noBackground}) => {
  return (
    <div className="box nd-grid formBox--container s-grid-1 m-grid-2 rows-gap-1">
      {children}
    </div>
  );
}

export default FormBox
